import { TFunction } from 'react-i18next'
import { GenderType } from 'src/api/api.generated'

export function displayGender(t: TFunction<'translation', undefined>, gender: GenderType): string {
  const key = `commons.gender_type.${gender.toLowerCase()}`
  return t(key as any)
}

export function displayGenderShort(t: TFunction<'translation', undefined>, gender: GenderType): string {
  const key = `commons.gender_type_short.${gender.toLowerCase()}`
  return t(key as any)
}

export const genderList: GenderType[] = Object.keys(GenderType).map((k) => GenderType[k as GenderType])
